module.exports = __webpack_public_path__ + "static/sdk-stickers-634445013704c58aaedc7b682358ad6b.gif";